import React, { useEffect, useState, useContext } from 'react'
import { InfoWindow } from '@react-google-maps/api'

import Skeleton from 'react-loading-skeleton'
import { DashboardContext } from 'live/context/dashboard'
import i18n from 'live/services/i18n'
import styled from 'styled-components'
import TripsContext from '../../contexts/TripsContext'
import { buildReverseGeocodeId, fillGoogleReverseGeocode, LatLngReverse } from '../../api/google-integration'
import { getCarStatusStyle, getBlockedStatusIcon, getBlockedStatusStyle } from '../../utils'
import { getInfoLocation } from '../../api/fleet'

type IProps = {
    vehicle
    hardware?
    avaregaSpeed?: string
    totalDistance?: string
    onClose?(): void
    showTripsBtn: boolean
}

const InfowindowVehicle = ({ vehicle = {}, hardware = {}, onClose, showTripsBtn = true }: IProps) => {
    const { reverseGeocoding, hardwareData, setIsNavegateToTrips, setInfoWindow, setVehiclesSearched } = useContext(
        TripsContext
    )
    const context: any = useContext(DashboardContext)
    const { title = '', license_plate = '', driver = '', imei } = vehicle
    const { car_status = '', collection } = hardware
    const [infoLocation, setInfoLocation] = useState<any>()
    const [address, setAddress] = useState('N/D')
    const { lat = 0, lng = 0 } = hardware

    useEffect(() => {
        getInfoLocation(collection, context?.params?.span, imei).then(response => {
            const { distance = 'N/A', speed = 'N/A' } = response.data || {}
            setInfoLocation({ distance, speed })
        })
    }, [context?.params?.span, imei])

    const fetchAddress = async (latLngsReverse: LatLngReverse[]) => {
        const newAddress = await fillGoogleReverseGeocode(reverseGeocoding, latLngsReverse)
        setAddress(newAddress?.address || 'N/D')
    }

    useEffect(() => {
        const foundAddress = reverseGeocoding[buildReverseGeocodeId(lat, lng)]?.address

        if (foundAddress) {
            setAddress(foundAddress)
        } else {
            const latLngsReverse: LatLngReverse[] = []
            latLngsReverse.push({ lat, lng })

            fetchAddress(latLngsReverse)
        }
    }, [hardwareData])

    const navegateToTrip = () => {
        setIsNavegateToTrips({ vehicle, hardwareData })
        setVehiclesSearched(undefined)
        setInfoWindow(undefined)
    }

    return (
        // <InfoWindow position={{ lat, lng }} onCloseClick={onClose}>
        <StyledPopup>
            <StyledUl showBorder={showTripsBtn}>
                <StyledLi>
                    <div>
                        <i style={getCarStatusStyle(car_status)} className={`fas fa-circle`}></i>
                    </div>
                    <div>
                        <div className="li-title">{title}</div>
                        <div>{license_plate}</div>
                    </div>
                </StyledLi>
                <StyledLi>
                    <div>
                        <i className={`far fa-map-marker-alt`}></i>
                    </div>
                    <div>{address}</div>
                </StyledLi>
                <StyledLi>
                    <div>
                        <i className={`far fa-tachometer-alt-average`}></i>
                    </div>
                    <div>
                        <div className="d-flex">
                            <div className="item-separator">{infoLocation?.speed} km/h</div>
                            <div>
                                <i className={`far fa-road`}></i>
                                {infoLocation?.distance} km total
                            </div>
                        </div>
                    </div>
                </StyledLi>
            </StyledUl>

            <StyledActions>
                {showTripsBtn && (
                    <button id="navegate-trips" onClick={navegateToTrip}>
                        <i className={`fas fa-route`}></i>
                        {i18n('Trips')}
                    </button>
                )}
            </StyledActions>
        </StyledPopup>
        // </InfoWindow>
    )
}

export default React.memo(InfowindowVehicle)

const StyledPopup = styled.div`
    min-width: 232px;
    max-width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 3px 6px;
`
const StyledUl = styled.ul`
    padding-bottom: 4px;
    border-bottom: ${({ showBorder }) => (showBorder ? '1px solid #c8ccd4' : 'none')};
`

const StyledActions = styled.div`
    display: flex;
    color: #37a3ef;
    font-weight: 600;

    button {
        background: none;
        border-width: 0;
        flex: 1;

        i {
            margin-right: 4px;
        }
    }
`

const StyledLi = styled.li`
    padding-bottom: 4px;
    font-size: 12px;
    display: flex;
    font-weight: 400;

    .item-separator {
        &::after {
            content: '|';
            margin: 0px 8px;
            color: #bac0cb;
        }
    }

    .li-title {
        text-transform: uppercase;
        font-weight: 600;

        .status-block {
            margin-left: 5px;
        }
    }

    i {
        color: #868695;
        font-size: 11px;
        width: 20px;
    }
`
